//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Candida',
  data() {
    return {
      form:{
        sepsis:'0',
        parenteral:'0',
        surgery:'0',
        multifocal:'0',
      },
      hasScore:false,
      disabled:false,
      Multifocal_Candida_Colonization_hint: "念珠菌同时从多个无接触传染可能性的位点分离到：粪便/直肠拭子或 尿液  或 呼吸道 或 皮肤 或口咽/胃",
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // 2 * sepsis + parenteral + surgery + multifocal
        let result = 2 * form.sepsis + form.parenteral + form.surgery + form.multifocal
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/Candida.vue